import { FC, useContext } from 'react';

import { Button, ButtonVariant, Image, Typography, Icon } from '@/shared/ui';

import { formatDate } from '@/helpers/dates';
import { imageBase64 } from '@/helpers/fileHelper';

import { RmpcTattooShort } from '@/api/integrations/rmpc/types/types';

import { TattooSearchContext } from '../../../context/TattooSearchContext';

import './RelatedTattoosList.scss';

interface RelatedTattoosListProps {
  related: RmpcTattooShort[];
}

export const RelatedTattoosList: FC<RelatedTattoosListProps> = ({ related }) => {
  const { handleDetails } = useContext(TattooSearchContext);

  return (
    <div className="tattoo-details__modal-related">
      <Typography variant="H2" className="tattoo-details__modal-related-title">
        У цієї особи є ще татуювання
      </Typography>
      <div className="tattoo-details__modal-related-list">
        {related.map((relatedTattoo) => (
          <div key={relatedTattoo.number} className="tattoo-details__modal-related-item">
            {relatedTattoo.image && (
              <div className="tattoo-details__modal-related-image-wrapper">
                <Image
                  src={imageBase64(relatedTattoo.image)}
                  alt={`Татуювання ${relatedTattoo.number}`}
                  className="tattoo-details__modal-related-image"
                />
              </div>
            )}
            <div className="tattoo-details__modal-related-info">
              <Typography variant="TEXT14" color="graphite">
                Додано: {formatDate(relatedTattoo.published_at)}
              </Typography>
              <Button
                variant={ButtonVariant.ICON_GHOST}
                onClick={() => handleDetails(relatedTattoo)}
                className="tattoo-details__modal-related-button"
              >
                Детальніше <Icon name="arrow_forward" />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
